import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { MenuItem, Select, TextField, Chip, Autocomplete } from '@mui/material';
import { useFeatureInext } from './hooks/useFeatureInext';
import { Close } from '@mui/icons-material';

export type addFeatureInextProps = {
    changeAlert: any;
    onConfirm: (data: any, tab: string, update: boolean) => void;
    onClose: () => void;
    open: boolean;
    title: string;
    tab: string;
    roles: Array<object>;
    menu: Array<object>;
    categoryMenu: Array<object>;
    data?: any;
}


export const FeatureInext = ({ onConfirm, onClose, open, title, tab, roles, menu, categoryMenu, data }: addFeatureInextProps & DefaultComponentProps) => {
    const { form, isValidForm, onHandleChange, onDelete } = useFeatureInext(open, tab, data)

    const autocompleteBox = (item, arr, prop, text) => {
        return <Autocomplete
            value={arr.map((option) => option)}
            options={arr}
            onChange={onHandleChange.bind(this, item, prop)}
            renderTags={(value, props) => value.map((option, index) => (
                <Chip key={`option-${index}`} label={option} {...props({ index })}/>
            ))}
            renderInput={(params) => <TextField label={text} {...params} color='secondary' />}
            multiple freeSolo clearIcon={false} size='small' fullWidth
        />
    }
    return (
        <Dialog onClose={onClose} open={open} style={{minWidth: tab === 'widget' && data ? '90%' : '600px', maxHeight: '500px'}}>
            <DialogTitle>
                <Typography variant='h2'>{title}</Typography>
            </DialogTitle>
            <DialogContent style={{paddingTop: 30}}>
                <FlexGrid container direction='column' spacing={2}>
                <FlexGrid container alignItems='stretch' spacing={2}>
                    <TextField value={form['key'] || ''} disabled={data ? true : false } onChange={onHandleChange.bind(this, 'key', null)} label='Key' size='small' color='secondary' fullWidth/>
                    <Select MenuProps={{style: {zIndex: 35001}}}
                        defaultValue={'-1'} onChange={onHandleChange.bind(this, 'roles', null)} size='small' color='secondary' fullWidth>
                            <MenuItem value={'-1'} disabled>Roles</MenuItem>
                            {roles?.map((item, index) => (
                                <MenuItem disabled={form['roles']?.indexOf(item['key']) > -1} key={`rol-${index}`} value={item['key']}>{item['label']}</MenuItem>
                            ))}
                    </Select>
                </FlexGrid>
                {tab === 'menu' &&
                    <FlexGrid container alignItems='stretch' spacing={2}>
                        <Select MenuProps={{style: {zIndex: 35001}}}
                            value={form?.['type'] || '-1'} onChange={onHandleChange.bind(this, 'type', null)} size='small' color='secondary' fullWidth>
                            <MenuItem value={'-1'} disabled>Tipo</MenuItem>
                            {menu?.map((item, index) => (
                                <MenuItem key={`type-${index}`} value={item['value']}>{item['label']}</MenuItem>
                            ))}
                        </Select>
                        {form?.['type'] === 'secondary' && 
                            <Select MenuProps={{style: {zIndex: 35001}}}
                            value={form?.['category'] || '-1'} onChange={onHandleChange.bind(this, 'category', null)} size='small' color='secondary' fullWidth>
                                <MenuItem value={'-1'} disabled>Categoría</MenuItem>
                                {categoryMenu?.map((item, index) => (
                                    <MenuItem key={`category-${index}`} value={item['label']}>{item['label']}</MenuItem>
                                    ))}
                            </Select>
                        }
                        {form?.['type'] !== 'secondary' && <TextField value={form['name'] || ''} onChange={onHandleChange.bind(this, 'name', null)} label='Nombre' size='small' color='secondary' fullWidth/>}
                    </FlexGrid>
                }
                {tab === 'menu' && form?.['type'] === 'secondary' &&
                    <TextField value={form['name'] || ''} onChange={onHandleChange.bind(this, 'name', null)} label='Nombre' size='small' color='secondary' style={{width: '49%'}}/>
                }
                {tab !== 'menu' &&
                    <TextField value={form['description'] || ''} onChange={onHandleChange.bind(this, 'description', null)} label='Descripción' size='small' color='secondary' fullWidth/>
                }
                {form['roles']?.length > 0 && 
                    <FlexGrid container direction='column' alignItems='stretch' spacing={2} style={{paddingTop: 20}} fullWidth>
                        {form['roles'].map((item, index) => {
                            return (
                                <FlexGrid key={index} container alignItems='center' spacing={2} fullWidth>
                                    <FlexGrid container fullWidth alignItems='center'>
                                        <Close fontSize='small' onClick={() => onDelete(item)} titleAccess={`Eliminar`} cursor={'pointer'} sx={{marginRight: 1}}/> 
                                        {item}
                                    </FlexGrid>
                                    {tab === 'intent' && 
                                        <Select MenuProps={{style: {zIndex: 35001}}}
                                            value={form['factor'] && form['factor'][item] ? form['factor'][item] : null} defaultValue={'-1'} onChange={onHandleChange.bind(this, 'factor', item)} size='small' color='secondary' fullWidth>
                                            <MenuItem value={'-1'} disabled>factor</MenuItem>
                                                <MenuItem value={'pass'}>Pass</MenuItem>
                                                <MenuItem value={'none'}>None</MenuItem>
                                                <MenuItem value={'1FA'}>1FA</MenuItem>
                                                <MenuItem value={'2FA'}>2FA</MenuItem>
                                        </Select>
                                    }
                                    {tab === 'widget' && form['config'][item] && form['config'][item]['actions'] &&
                                        autocompleteBox(item, form['config'][item]['actions'], 'action', 'Acciones')
                                    }
                                    {tab === 'widget' && form['config'][item] && form['config'][item]['fields'] && form['config'][item]['fields']['in'] &&
                                        autocompleteBox(item, form['config'][item]['fields']['in'], 'in', 'Incluir campos')
                                    }
                                    {tab === 'widget' && form['config'][item] && form['config'][item]['fields'] && form['config'][item]['fields']['ex'] &&
                                        autocompleteBox(item, form['config'][item]['fields']['ex'], 'ex', 'Excluir campos')
                                    } 
                                </FlexGrid>
                            )
                        })}
                    </FlexGrid>
                }
                </FlexGrid>
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify='space-between' alignItems='space-between' style={{ marginTop: '20px', display: 'flex' }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{textAlign: 'end'}}>
                        <Button onClick={() => onConfirm(form, tab, (data ? true : false))} disabled={isValidForm} size='normal'>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}

export default FeatureInext;
